module.exports = __webpack_public_path__ + "static/media/taetigkeitsfelder_2025.76c8c68b.png";